<template>
  <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
    <div class="well form-group" style="background: #e5e9ec">
      <!-- title -->
      <div class="grid-title no-border borderTop" style="display: flex; justify-content: flex-end; align-items: center; padding-right: 20px;">
        <el-button v-if="componentsMap.get('silo_add')"
          @click="turnVisible()" 
          icon="fas fa-plus"
          id="searchButton"
          size="small"
          class="btn-primary"
        >
          {{ i18nValues["enter"] }}
        </el-button>
      </div>
      

      <!-- form -->
      <div class="grid-body no-border borderBottom">
        <el-form v-loading="loading != 0">

          <div class="box-icons-container">
            <div v-for="silo in SilosList" :key="silo.id" class="box-icon-container">

              <div v-if="silo.type === 'discard' && calcPercentage(silo) == 0 " class="image-container">
                  <img :src="require('assets/discard_silo.jpeg')" width="200" height="200"/>
              </div>

              <div v-if="silo.type === 'discard' && calcPercentage(silo) > 0 && calcPercentage(silo) < 20" class="image-container">
                  <img :src="require('assets/discard_silo_img1.jpeg')" width="200" height="200"/>
              </div>

              <div v-if="silo.type === 'discard' && calcPercentage(silo) >= 20 && calcPercentage(silo) < 30" class="image-container">
                  <img :src="require('assets/discard_silo_img2.jpeg')" width="200" height="200"/>
              </div>

              <div v-if="silo.type === 'discard' && calcPercentage(silo) >= 30 && calcPercentage(silo) < 50" class="image-container">
                  <img :src="require('assets/discard_silo_img3.jpeg')" width="200" height="200"/>
              </div>

              <div v-if="silo.type === 'discard' && calcPercentage(silo) >= 50 && calcPercentage(silo) < 70" class="image-container">
                  <img :src="require('assets/discard_silo_img4.jpeg')" width="200" height="200"/>
              </div>

              <div v-if="silo.type === 'discard' && calcPercentage(silo) >= 70 && calcPercentage(silo) < 90" class="image-container">
                  <img :src="require('assets/discard_silo_img5.jpeg')" width="200" height="200"/>
              </div>

              <div v-if="silo.type === 'discard' && calcPercentage(silo) >= 90 && calcPercentage(silo) < 100" class="image-container">
                  <img :src="require('assets/discard_silo_img6.jpeg')" width="200" height="200"/>
              </div>

              <div v-if="silo.type === 'discard' && calcPercentage(silo) == 100" class="image-container">
                  <img :src="require('assets/discard_silo_full.jpeg')" width="200" height="200"/>
              </div>
            
              <div v-else-if="silo.type !== 'discard'">
                  <div v-if="calcPercentage(silo) > 0 && calcPercentage(silo) < 20" class="image-container">
                      <img :src="require('assets/silo_img1.jpeg')" width="200" height="200"/>
                  </div>
                  <div v-else-if="calcPercentage(silo) >= 20 && calcPercentage(silo) < 30" class="image-container">
                      <img :src="require('assets/silo_img2.jpeg')" width="200" height="200"/>
                  </div>
                  <div v-else-if="calcPercentage(silo) >= 30 && calcPercentage(silo) < 50" class="image-container">
                      <img :src="require('assets/silo_img3.jpeg')" width="200" height="200"/>
                  </div>
                  <div v-else-if="calcPercentage(silo) >= 50 && calcPercentage(silo) < 70" class="image-container">
                      <img :src="require('assets/silo_img4.jpeg')" width="200" height="200"/>
                  </div>
                  <div v-else-if="calcPercentage(silo) >= 70 && calcPercentage(silo) < 90" class="image-container">
                      <img :src="require('assets/silo_img5.jpeg')" width="200" height="200"/>
                  </div>
                  <div v-else-if="calcPercentage(silo) >= 90 && calcPercentage(silo) < 100" class="image-container">
                      <img :src="require('assets/silo_img6.jpeg')" width="200" height="200"/>
                  </div>
                  <div v-else-if="calcPercentage(silo) == 100" class="image-container">
                      <img :src="require('assets/silo_full.jpeg')" width="200" height="200"/>
                  </div>
                  <div v-else-if="calcPercentage(silo) == 0" class="image-container">
                      <img :src="require('assets/silo.jpeg')" width="200" height="200"/>
                  </div>
              </div>

              <div class="text-container">
                <p class="box-name-title">{{ silo.name }}</p>
                <div class="info-container">
                  <p class="box-name-capacity"> {{ i18nValues['capacity'] }} {{ calcPercentage(silo) }} % </p>

                  <el-button v-if="componentsMap.get('silo_clear') && !silo.pending"
                            class="box-button"                    
                            icon="fas fa-broom"
                            size="small"
                            :title="i18nValues['clear']"
                            :disabled="(silo.usedKg === 0 && silo.field === null && silo.product === null) || (silo.status === 'inTara')"
                            @click="clear(silo.id)"
                  ></el-button>

                  <el-button v-else-if="silo.pending && componentsMap.get('silo_confirm_clear')"
                            class="box-button"                    
                            icon="fas fa-triangle-exclamation"  
                            size="small"                         
                            :title="i18nValues['clear']"
                            @click="confirmClear(silo.id)"
                  ></el-button>

                  <el-button v-else-if="silo.pending && !componentsMap.get('silo_confirm_clear')"
                            class="box-button"                    
                            icon="fas fa-triangle-exclamation"  
                            size="small"                         
                            :title="i18nValues['clear']"
                  ></el-button>

                </div>

                <p class="box-name">{{ formatUsedKg(silo.usedKg) }} Kg </p>
                <p class="box-name-product" v-if="silo.product"> {{ silo.product.brand }} </p>
                <p class="box-name-product" v-if="silo.field"> {{ silo.field.name }} </p>
                <div class="box-name-product">
                  <el-button v-if="silo.type == 'discard'"
                            class="box-button"                    
                            icon="fas fa-recycle"  
                            size="small"           
                            style="text-align: center !important; margin-top: 10px !important; margin-left: 4% !important;"         
                            :title="i18nValues['clear']"
                ></el-button>
                </div>
                
              </div>


            </div>
          </div>

        <!-- </el-form>

        <el-form v-loading="loading != 0"> -->

          <h4>{{ i18nValues["movementsMade"] }}</h4>

          <div class="filters-wrapper">
            <div class="filters-row">
              <el-form-item :label="i18nValues['operation']" prop="operation">
                <el-select  
                  v-model="filter.operation"
                  :placeholder="i18nValues['operation']"
                  filterable
                >
                    <el-option :value="null"></el-option>
                    <el-option
                      v-for="item in operationsList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="i18nValues['silo']" prop="silo">
                <el-select  
                  v-model="filter.silo"
                  :placeholder="i18nValues['silo']"
                  filterable
                >
                    <el-option :value="null"></el-option>
                    <el-option
                      v-for="item in SilosList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="i18nValues['truckPlate'] || 'Truck Plate'" prop="truckPlate">
                <el-input
                  v-model="filter.truckPlate"
                  :placeholder="i18nValues['truckPlate'] || 'Truck Plate'"
                ></el-input>
              </el-form-item>

              <el-button
                @click="retrieveMovementsBySearch()"
                icon="fas fa-search"
                id="searchButton"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["search"] }}
              </el-button>

              <el-button
                icon="fas fa-file-excel"
                size="small"
                class="btn-primary"
                @click="exportExcel()"
              >
                {{ i18nValues["export"] }}
              </el-button>
            </div>
          </div>

          

          <el-form-item prop="silos">
            <div class="full-width" style="margin:0 auto;padding:20px;">
              <el-table
                id="MovementsTable"
                :data="MovementsSubList"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                class="table table-hover"
                stripe
                align="center"
                :empty-text="i18nValues['noDataAvailable']"
                :tree-props="{ children: 'items' }"
                :default-sort="tableDefaultSort"
                @sort-change="handleSortChange"
              >

                <!-- Silo -->
                <el-table-column
                  prop="silo.name"
                  :label="i18nValues['silo']"
                  width="110"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Brand -->
                <el-table-column
                  prop="product.brand"
                  label="Brand"
                  width="160"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Variety -->
                <el-table-column
                  prop="product.name"
                  :label="i18nValues['variety']"
                  width="110"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Field -->
                <el-table-column
                  prop="field.name"
                  :label="i18nValues['field']"
                  width="140"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- FielLots -->
                <el-table-column
                  prop="fieldLot.name"
                  :label="i18nValues['batch']"
                  width="85"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Date -->
                <el-table-column
                  prop="date"
                  :label="i18nValues['date']"
                  :formatter="formatDate"
                  width="140"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Operation -->
                <el-table-column
                  prop="operation"
                  :label="i18nValues['operation']"
                  width="140"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Crop -->
                <el-table-column
                  prop="cropType"
                  :label="i18nValues['crop']"
                  width="140"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Kg -->
                <el-table-column
                  prop="kg"
                  label="Kg"
                  width="80"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Intial Quantity -->
                <el-table-column
                  prop="initialQuantity"
                  :label="i18nValues['initialKg']"
                  width="110"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Final Quantity -->
                <el-table-column
                  prop="finalQuantity"
                  :label="i18nValues['finalKG']"
                  width="100"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Humidity -->
                <el-table-column
                  prop="humidity"
                  :label="i18nValues['humidity']"
                  width="110"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Temperature -->
                <el-table-column
                  prop="temperature"
                  :label="i18nValues['temperature']"
                  width="130"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- ps1000 -->
                <el-table-column
                  prop="ps1000"
                  label="PS1000"
                  width="87"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Visual Quality -->
                <el-table-column
                  prop="visualQualityLabel"
                  :label="i18nValues['quality']"
                  width="94"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Comment -->
                <el-table-column
                  prop="comment"
                  :label="i18nValues['comment']"
                  width="170"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Transport Date -->
                <el-table-column
                  prop="transportDate"
                  :label="i18nValues['entryDate']"
                  :formatter="formatDate"
                  width="137"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Refer -->
                <el-table-column
                  prop="refer"
                  :label="i18nValues['refer']"
                  width="95"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- carrierCompany -->
                <el-table-column
                  prop="carrierCompany"
                  :label="i18nValues['transport']"
                  width="140"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Driver -->
                <el-table-column
                  prop="driver"
                  :label="i18nValues['driver']"
                  width="100"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Truck Plate -->
                <el-table-column
                  prop="truckPlate"
                  :label="i18nValues['truckPlate']"
                  width="146"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Trailer Plate -->
                <el-table-column
                  prop="trailerPlate"
                  :label="i18nValues['trailerPlate']"
                  width="146"
                  align="left"
                  sortable
                ></el-table-column>

                <el-table-column width="85" fixed="right">
                  <template slot-scope="scope">

                    <el-button
                      v-if="!componentsMap.get('silo_save_trx') || !componentsMap.get('silo_save')"
                      class="text-info"
                      icon="fa fa-eye"
                      size="small"
                      :title="i18nValues['view']"
                      @click="edit(scope.row)"
                    ></el-button>

                    <template v-else>
                      <el-button
                        v-if="scope.row.operation === i18nValues['seedIncome'] || 
                              scope.row.operation === 'added' || 
                              scope.row.status === 'finalized'"
                        class="text-info"
                        icon="fas fa-edit"
                        size="small"
                        :title="i18nValues['edit']"
                        @click="edit(scope.row)"
                      ></el-button>
                      <el-button
                        v-if="(scope.row.operation === i18nValues['inTara'] || scope.row.operation === 'inTara') &&
                              scope.row.status !== 'finalized'"
                        class="text-info"
                        icon="fas fa-truck"
                        size="small"
                        :title="i18nValues['edit']"
                        @click="editTara(scope.row)"
                      ></el-button>
                    </template>
                  </template>
                </el-table-column>

              </el-table>
            </div>
          </el-form-item>
          <div v-if="90 > 10" style="height: 15px"></div>

          <div class="pagination-bar">
            <PaginationFunctional
              ref="pagination"
              sublistName="MovementsSubList"
              :fullList.sync="MovementsList"
              :tableSize="20"
              :tableIndexInitial="initialPage"
              @paginationChange="paginationChange"
              @currentIndexPagination="setCurrentPage"
              class="text-center"
            />
            <div v-if="MovementsList.length > 0" class="results-info">
              <p>
                {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
              </p>
            </div>
          </div>

        </el-form>

        <!-- Silos Modals -->  

        <el-form>
          <HopperModal
            :modalTitle="i18nValues['rawMaterialInput']"
            :visible.sync="visibleModal"
            :SilosList="this.SilosList"
            :isTaraOperation="isTaraOperation"
            ref="hopperModal"
            actionIcon="fas fa-edit"
            actionTitle="edit"
            v-on:update:Silos="updateSilos"
          ></HopperModal>


          <SiloTransferModal
            :modalTitle="i18nValues['clearSilo']"
            :visible.sync="visibleModalSiloTrasnfer"
            :siloInfo="siloInfo"
            ref="SiloTransferModal"
            actionIcon="fas fa-edit"
            actionTitle="edit"
            @updateSilos="updateSilos"
          ></SiloTransferModal>

          <SiloMovementModal
            :modalTitle="i18nValues['incomeMade']"
            :visible.sync="visibleMovementModal"
            :siloTrx="siloTrx"
            :SilosList="this.SilosList"
            :componentsMap="componentsMap"
            ref="SiloMovementModal"
            actionIcon="fas fa-edit"
            actionTitle="edit"
            @updateSilos="updateSilos"
          ></SiloMovementModal>
        </el-form>
        
      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import HopperModal from "../../components/customer/invoicingmodule/modals/HopperModal.vue"; // eslint-disable-line no-unused-vars
import SiloTransferModal from "../../components/customer/invoicingmodule/modals/SiloTransferModal.vue"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue"
import SiloMovementModal from "../../components/customer/invoicingmodule/modals/SiloMovementModal.vue"; // eslint-disable-line no-unused-vars


export default {
  name: "FieldSection",
  created() {
    // Restore filter UI from URL on mount.
    // All data fetching is handled by the globalFieldSite watcher (immediate: true).
    this.restoreFromQuery();
  },

  components: {
    HopperModal,
    SiloTransferModal,
    PaginationFunctional,
    SiloMovementModal
  },

  computed: {
    loading: get("silo/loading"),
    globalFieldSite: get("globalFieldSite"),
    selectedLanguage: get("i18nStore/selectedLanguage"),

      operationsList() {
        return [
          {id: 1, name: this.i18nValues['seedIncome'], value: "add"},
          {id: 2, name: this.i18nValues['mpConsumption'], value: "withdrawal"},
          {id: 3, name: this.i18nValues['inTara'], value: "inTara"},
          {id: 4, name: this.i18nValues['discard'] || 'Descarte', value: "discard"}
        ];
      },

      // Pagination helpers for results label
      currentPage() {
        if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
          return this.$refs.pagination.tableIndex;
        }
        if (typeof this.currentPageIndex === "number") {
          return this.currentPageIndex;
        }
        return this.initialPage || 1;
      },
      pageSize() {
        return 20; // Keep in sync with PaginationFunctional :tableSize
      },
      totalRecords() {
      if (Array.isArray(this.MovementsList)) {
        return this.MovementsList.length;
      }
      return typeof this.cantidad === "number" ? this.cantidad : 0;
      },
      startIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const start = (this.currentPage - 1) * this.pageSize + 1;
        return Math.min(start, this.totalRecords);
      },
      endIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const end = this.currentPage * this.pageSize;
        return Math.min(end, this.totalRecords);
      },

      tableDefaultSort() {
        if (this.sortProp && this.sortOrder) {
          return { prop: this.sortProp, order: this.sortOrder };
        }
        return {};
      },
  },

  props:{
    componentsMap: {},
  },

  watch: {
      globalFieldSite: {
        handler(newVal, oldVal) {
          if (!newVal || !newVal.id) return;
          // Skip if the ID hasn't changed (e.g. partial → full object update from TopBar)
          if (oldVal && oldVal.id === newVal.id) return;
          // Invalidate all in-flight requests
          this.requestGeneration++;
          this.retrieveSilos();
          // When fieldSite actually changes (not initial load), reset filters & page
          var isChange = oldVal && oldVal.id && oldVal.id !== newVal.id;
          if (isChange) {
            this.filter = { operation: null, silo: null, truckPlate: null };
            this.initialPage = 1;
            this.currentPageIndex = 1;
            this.sortProp = null;
            this.sortOrder = null;
          }
          this.fetchMovements(true);
          this.retrieveMovementCount();
          this.syncRouteFromState();
        },
        immediate: true,
      },
      i18nValues: {
        handler() {
          this.retrieveSilos();
        },
        deep: true,
      },
  },

  data() {
    const q = (this.$route && this.$route.query) || {};
    return {

      visibleModal: false,
      SilosList: [],
      SilosToClearList: [],
      discardSilo: {},
      visibleModalSiloTrasnfer: false,
      siloInfo: {},
      MovementsList:[],
      MovementsSubList: [],
      visibleMovementModal: false,
      siloTrx: {},
      filter: {
        operation: q.operation || null,
        silo: q.silo ? Number(q.silo) : null,
        truckPlate: q.truckPlate || null,
      },
      isTaraOperation: false,
      cantidad: 100,
      initialPage: q.page ? Number(q.page) : 1,
      currentPageIndex: 1,
      sortProp: q.sortProp || null,
      sortOrder: q.sortOrder || null,
      requestGeneration: 0,

    };
  },
  methods: {

    retrieveSilos() {
      let fieldSiteId = this.globalFieldSite ? this.globalFieldSite.id : null;

      this.$store.dispatch("silo/retrieveSilos", { id: fieldSiteId }).then((res) => {
          this.SilosList = res.sort((a, b) => {
              if (a.type === 'discard' && b.type !== 'discard') {
                  return 1; 
              }
              if (a.type !== 'discard' && b.type === 'discard') {
                  return -1; 
              }

              const nameA = a.name.match(/\d+/); 
              const nameB = b.name.match(/\d+/);

              const numA = nameA ? parseInt(nameA[0], 10) : 0; 
              const numB = nameB ? parseInt(nameB[0], 10) : 0;

              if (numA !== numB) {
                  return numA - numB; 
              }
              return a.name.localeCompare(b.name);
          });

          const silo = this.SilosList.find(silo => silo.type === 'discard');
          if (silo) {
              silo.name = this.i18nValues["discard"];
          } 
      });
    },

    retrieveSilosToClearList() {
      let fieldSiteId = this.globalFieldSite ? this.globalFieldSite.id : null;
      this.$store.dispatch("silo/retrieveSilosToClear", { id: fieldSiteId}).then((res) => {
          this.SilosToClearList = res;
          const silo = this.SilosList.find(silo => silo.type === 'discard');
          if (silo) {
              silo.name = this.i18nValues["discard"];
          }
          // console.log("Silo a vaciar: ", this.SilosToClearList ); //eslint-disable-line
      });
    },

    turnVisible() {
      this.isTaraOperation = true;
      this.visibleModal = true;
    },

    updateSilos() {
      this.retrieveSilos();
      this.retrieveSilosToClearList();
      if (this.filter.operation != null || this.filter.silo != null ) {
        this.retrieveMovementsBySearch();
      } else {
        this.retrieveMovements()
      }
      this.retrieveMovementCount();
    },

    clear(siloId) {
      this.checkSiloDiscardCapacity(siloId).then(isCapacityAvailable => {
          if (!isCapacityAvailable) {
              this.$notify.error({
                  title: this.i18nValues["error"],
                  message: this.i18nValues["SiloDiscardNoCapacity"], 
                  position: "bottom-right",
              });
              return; 
          }
          this.siloInfo = this.SilosList.find(silo => silo.id === siloId) || {};
          this.visibleModalSiloTrasnfer = true;
      });
    },

    confirmClear(siloId) {
      this.checkSiloDiscardCapacity(siloId).then(isCapacityAvailable => {
        if (!isCapacityAvailable) {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: this.i18nValues["SiloDiscardNoCapacity"],
            position: "bottom-right",
          });
          return;  
        }

        this.siloInfo = this.SilosList.find(silo => silo.id === siloId) || {};
        this.visibleModalSiloTrasnfer = true;
      });
    },


    checkSiloDiscardCapacity(siloId) {
      return new Promise((resolve) => {
          const siloToEmpty = this.SilosList.find(silo => silo.id === siloId);
          const siloDiscard = this.SilosList.find(silo => silo.type === 'discard');

          if (siloToEmpty === siloDiscard) {
              resolve(true);
              return
          }

          if (!siloToEmpty || siloToEmpty.usedKg === 0) {
              resolve(true);
              return;
          }

          if (siloDiscard) {
              const maxCapacity = siloDiscard.maxKg;
              const currentUsed = siloDiscard.usedKg;
              const newUsedKg = currentUsed + siloToEmpty.usedKg;

              resolve(newUsedKg < maxCapacity);
          } else {
              resolve(true);
          }
      });
    },

    // Central fetch — called by watcher & user actions. preservePage=true keeps current page.
    fetchMovements(preservePage) {
      if (!this.globalFieldSite || !this.globalFieldSite.id) return;
      var fieldSiteId = this.globalFieldSite.id; // capture at call time, not at response time
      var hasFilters = !!(this.filter.operation || this.filter.silo || this.filter.truckPlate);
      var gen = ++this.requestGeneration;

      var promise = hasFilters
        ? this.$store.dispatch("silo/retrieveMovementsBySearch", {
            operation: this.filter.operation,
            silo: this.filter.silo,
            truckPlate: this.filter.truckPlate,
            fieldSiteId: fieldSiteId,
          })
        : this.$store.dispatch("silo/retrieveMovements", { fieldSiteId: fieldSiteId });

      promise.then((res) => {
        if (gen !== this.requestGeneration) return; // stale response — discard
        this.MovementsList = res;
        this.transaleteMovements(this.MovementsList);
        this.calculateKg(this.MovementsList);
        this.applyInitialSort();
        if (!preservePage) {
          this.initialPage = 1;
          this.currentPageIndex = 1;
        } else {
          this.currentPageIndex = this.initialPage || 1;
        }
        this.syncRouteFromState();
        this.$nextTick(() => {
          if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
            this.$refs.pagination.currentChange(this.currentPageIndex);
          }
        });
      });
    },

    // Aliases so existing callers (updateSilos, template) keep working
    retrieveMovements() {
      this.fetchMovements(true);
    },

    retrieveMovementsBySearch(preservePage) {
      this.fetchMovements(preservePage);
    },

    calculateKg(list) {
      list.forEach(silo => {
        if ( silo.initialQuantity != null && silo.finalQuantity != null || silo.operation === this.i18nValues['seedIncome']) {
          if (silo.operation === "add" || silo.operation ===  "Ingreso de Semilla") {
            silo.kg = silo.finalQuantity - silo.initialQuantity;
          } else if (silo.operation === "withdrawal" || silo.operation === this.i18nValues['mpConsumption']) {
            silo.kg = silo.initialQuantity - silo.finalQuantity;
          } else {
            silo.kg = null; 
          }
        } 
      });
    },


    transaleteMovements(list) {
      list.forEach(silo => {
            // Preserve raw operation value before translating for display
            silo.operationRaw = silo.operation;
            if (silo.operation === "add") {
              silo.operation = this.i18nValues['seedIncome']; 
            }
            if (silo.operation === "pending") {
              silo.operation = this.i18nValues['pending']; 
            }
            if (silo.operation === "clear") {
              silo.operation = this.i18nValues['clearConfirm']; 
            }
            if (silo.operation === "withdrawal") {
              silo.operation = this.i18nValues['mpConsumption']; 
            }
            if (silo.operation === "inTara") {
              silo.operation = this.i18nValues['inTara']; 
            }
            if (silo.operation === "discard") {
              silo.operation = this.i18nValues['discard'] || 'Descarte'; 
            }
            if (silo.cropType == "soy") {
              silo.cropType = this.i18nValues["soy"];
            }
            if (silo.cropType == "soyRD") {
              silo.cropType = this.i18nValues["soyRD"];
            }
            if (silo.cropType == "corn") {
              silo.cropType = this.i18nValues["corn"];
            }
            if (silo.visualQuality === "good") {
              silo.visualQualityLabel = this.i18nValues["good"];
            }
            if (silo.visualQuality === "regular") {
              silo.visualQualityLabel = this.i18nValues["regular"];
            }
            if (silo.visualQuality === "bad") {
              silo.visualQualityLabel = this.i18nValues["bad"];
            }
          });
    },

    formatDate(row) {
      return this.formatDateHour(row.date);
    }, 

    edit(row) {
      this.siloTrx = row;
      this.visibleMovementModal = true;
    },

    editTara(row) {
      this.isTaraOperation = false;
      this.siloTrx = row;
      this.visibleMovementModal = true;
    },

    exportExcel() {
      this.filter.fieldSiteId = this.globalFieldSite.id;
      this.filter.selectedLanguage = this.selectedLanguage || 'es';
      this.$store
        .dispatch("silo/exportExcelSilos", this.filter)
        .then((res) => {
          var blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          const links = document.createElement("a");
          links.href = URL.createObjectURL(blob);
          links.download = "Movimientos_Efectuados.xlsx";
          links.click();
          URL.revokeObjectURL(links.href);
        });
    },

    calcPercentage(silo) {
      if (!silo || !silo.maxKg || silo.maxKg === 0) return 0;
      var pct = Math.round((silo.usedKg || 0) / silo.maxKg * 100);
      return Math.min(pct, 100);
    },

    formatUsedKg(value) {
      if (value == null) return "0.00";
      return Number(value).toFixed(1);
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.MovementsSubList = evt.list;
      }
      var currentIdx = this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex
        : this.currentPageIndex;
      this.currentPageIndex = currentIdx || this.initialPage || 1;
      this.initialPage = this.currentPageIndex;
      this.syncRouteFromState();
    },

    setCurrentPage(idx) {
      if (typeof idx === "number") {
        this.currentPageIndex = idx;
        this.initialPage = idx;
        this.syncRouteFromState();
      }
    },

    retrieveMovementCount() {
      if (!this.globalFieldSite || !this.globalFieldSite.id) return;
      var gen = this.requestGeneration;
      var fieldSiteId = this.globalFieldSite.id;
      this.$store
        .dispatch("silo/countMovements", { fieldSiteId: fieldSiteId })
        .then((res) => {
          if (gen !== this.requestGeneration) return; // stale — discard
          this.cantidad = res;
        });
    },

    handleSortChange(event) {
      const nextProp = event && event.prop ? event.prop : null;
      const nextOrder = event && event.order ? event.order : null;
      const sortChanged =
        this.sortProp !== nextProp || this.sortOrder !== nextOrder;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;
      if (!sortChanged) {
        return;
      }
      // Always use local sorting for fieldLot.name (batch/lote) to ensure string sorting
      const useLocalSort = this.sortProp === "fieldLot.name";
      let sorted = null;
      if (!useLocalSort && this.$refs.pagination) {
        sorted = this.$refs.pagination.handleSortChangePagination(event);
      }
      if (!Array.isArray(sorted)) {
        sorted = this.sortMovementsLocally(
          this.MovementsList,
          this.sortProp,
          this.sortOrder
        );
      }
      if (Array.isArray(sorted)) {
        this.MovementsList = sorted;
        this.initialPage = 1;
        this.currentPageIndex = 1;
        this.syncRouteFromState();
        this.$nextTick(() => {
          if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === 'function') {
            this.$refs.pagination.currentChange(1);
          }
        });
      }
    },

    applyInitialSort() {
      if (
        !Array.isArray(this.MovementsList) ||
        !this.MovementsList.length ||
        !this.sortProp ||
        !this.sortOrder
      ) {
        return;
      }
      // Always use local sorting for fieldLot.name (batch/lote) to ensure string sorting
      const useLocalSort = this.sortProp === "fieldLot.name";
      let sorted = null;
      if (!useLocalSort && 
          this.$refs &&
          this.$refs.pagination &&
          typeof this.$refs.pagination.handleSortChangePagination === "function"
      ) {
        sorted = this.$refs.pagination.handleSortChangePagination(
          { prop: this.sortProp, order: this.sortOrder },
          this.MovementsList
        );
      }
      if (!Array.isArray(sorted)) {
        sorted = this.sortMovementsLocally(
          this.MovementsList,
          this.sortProp,
          this.sortOrder
        );
      }
      if (Array.isArray(sorted)) {
        this.MovementsList = sorted;
        // Ensure pagination is synced to the correct page from URL
        this.ensurePaginationSync();
      }
    },

    sortMovementsLocally(list, prop, order) {
      if (!Array.isArray(list) || !prop || !order) {
        return list;
      }
      const direction = order === "descending" ? -1 : 1;
      // Force string sorting for batch/lote column (fieldLot.name)
      // Batch values can be: '5', '19', 'Lote 30', 'a1', etc.
      // All should be sorted alphabetically as strings, not numerically
      const forceStringSort = prop === "fieldLot.name";
      return [...list].sort((a, b) => {
        const aVal = this.getValueByPath(a, prop);
        const bVal = this.getValueByPath(b, prop);
        if (this.isEmptyValue(aVal) && this.isEmptyValue(bVal)) {
          return 0;
        }
        if (this.isEmptyValue(aVal)) {
          return 1;
        }
        if (this.isEmptyValue(bVal)) {
          return -1;
        }
        // For batch/lote, always use string sorting (handles '5', '19', 'Lote 30', 'a1', etc.)
        // For other fields, use numeric sorting if both values are numeric
        if (!forceStringSort && this.isNumericValue(aVal) && this.isNumericValue(bVal)) {
          return (Number(aVal) - Number(bVal)) * direction;
        }
        // Use localeCompare for proper string sorting that handles mixed formats
        const comparison = String(aVal).localeCompare(String(bVal), undefined, {
          sensitivity: "base",
          numeric: false, // Explicitly disable numeric sorting for string comparison
        });
        return comparison * direction;
      });
    },

    getValueByPath(item, path) {
      if (!item || !path) {
        return null;
      }
      return path.split(".").reduce((acc, segment) => {
        if (acc === null || acc === undefined) {
          return null;
        }
        return acc[segment];
      }, item);
    },

    isEmptyValue(value) {
      return value === null || value === undefined || value === "";
    },

    isNumericValue(value) {
      if (typeof value === "number") {
        return !isNaN(value);
      }
      if (typeof value === "string" && value.trim() === "") {
        return false;
      }
      return !isNaN(Number(value));
    },

    ensurePaginationSync() {
      this.$nextTick(() => {
        if (
          this.$refs &&
          this.$refs.pagination &&
          typeof this.$refs.pagination.currentChange === "function"
        ) {
          const targetIndex =
            this.$refs.pagination.tableIndex || this.initialPage || 1;
          this.$refs.pagination.currentChange(targetIndex);
        } else if (Array.isArray(this.MovementsList)) {
          this.MovementsSubList = this.MovementsList.slice(0, this.pageSize);
        }
      });
    },

    // --- Query sync helpers ---

    restoreFromQuery() {
      var q = this.$route.query || {};
      this.filter = this.filter || {};
      this.filter.operation = q.operation || null;
      this.filter.silo = q.silo ? Number(q.silo) : null;
      this.filter.truckPlate = q.truckPlate || null;
      this.initialPage = q.page ? Number(q.page) : 1;
      this.sortProp = q.sortProp || null;
      this.sortOrder = q.sortOrder || null;
    },

    // Single method to push local state → URL. No cycles because it compares before navigating.
    syncRouteFromState() {
      var q = {};
      if (this.filter && this.filter.operation) q.operation = this.filter.operation;
      if (this.filter && this.filter.silo) q.silo = String(this.filter.silo);
      if (this.filter && this.filter.truckPlate) q.truckPlate = this.filter.truckPlate;

      var page = this.currentPageIndex || this.initialPage || 1;
      q.page = String(page);

      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;

      if (this.globalFieldSite && this.globalFieldSite.id) {
        q.fieldSiteId = String(this.globalFieldSite.id);
      }

      // Only navigate if the query actually changed — prevents cycles
      var currentQ = this.$route.query || {};
      var keys = Object.keys(q);
      var isSame = keys.length === Object.keys(currentQ).length &&
        keys.every(function(k) { return String(q[k]) === String(currentQ[k]); });
      if (isSame) return;

      this.$router.replace({ query: q }).catch(function() {});
    },

  },
};
</script>

<style scoped>
.box-icons-container {
  display: flex;
  flex-wrap: wrap; 
  justify-content: left; 
}

.box-icon-container {
  flex: 0 0 auto; 
  margin-right: 20px; 
}

.image-container {
  text-align: center; 
  margin-bottom: 20px; 
}

.text-container {
  text-align: center; 
  padding:15px; 
  border-radius: 5px; 
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.2;
}

.box-name-title {
  width: 100%; 
  text-align: center; 
  font-size: 18px; 
  font-weight: bold; 
  margin-bottom: 5px; 
  margin-top: -15px;
}

.box-name {
  width: 100%; 
  text-align: center; 
  margin-bottom: -5px;
  margin-right: 5px !important ; 
  /* margin-left: 8px; */
}

.box-name-product {
  width: 100%; 
  text-align: center; 
  margin-bottom: -5px;
  margin-right: 5px !important ; 
  margin-left: 1px;
}

.box-name-capacity {
  width: 100%; 
  text-align: left; 
  margin-bottom: -10px;
  margin-right: 5px !important ; 
  margin-left: 54px;
  margin-top: -10px;
}

.box-button {
  width: 91%;
  text-align: left;
  /* color: #333; */
  color: #6f7b8a;
  margin-bottom: 4px;
  margin-right: 50px;
}

.button-container {
  display: flex;
  align-items: center;
  margin-top: 10px; 
}

.el-button.box-button {
  border: none;
  background-color: transparent; 
  box-shadow: none; 
  padding: 0; 
}

.info-container {
  display: flex;
  justify-content: space-between; 
  align-items: center;
}

.title-container {
  display: flex;
  align-items: center; 
  margin-bottom: 20px;
}

.grid-title h4 {
  margin-right: 25px; 
}

/* Filters wrapper - consistent styling */
.filters-wrapper {
  margin-bottom: 20px;
}

.filters-row {
  display: flex;
  gap: 15px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filters-row .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

.filters-row .el-input,
.filters-row .el-select {
  width: 180px;
}

.filters-row .el-input >>> .el-input__inner,
.filters-row .el-select >>> .el-input__inner {
  border: 1px solid #dcdfe6;
}

.filters-row .el-date-editor {
  width: 180px;
}

.filters-row .el-date-editor >>> .el-input__inner {
  border: 1px solid #dcdfe6;
}

.filters-row .el-button {
  flex-shrink: 0;
}

/* Compress table to reduce scrolling */
#MovementsTable /deep/ .el-table th,
#MovementsTable /deep/ .el-table td {
  padding: 4px 8px !important;
  vertical-align: middle !important;
}

#MovementsTable /deep/ .el-table .cell {
  padding: 0 !important;
  line-height: 1.3 !important;
  font-size: 11px !important;
}

#MovementsTable /deep/ .el-table th {
  vertical-align: middle !important;
}

#MovementsTable /deep/ .el-table th .cell {
  font-size: 11px !important;
  font-weight: 500 !important;
  display: flex !important;
  align-items: center !important;
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}

</style>
